import React, { FC } from 'react';
import { ProfileView } from '../components';

export const ProfilePage: FC = () => {
  return <ProfileView />;
};
